/* this file added by Bearer Web Developer  */
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab';
import styles from './locations.module.scss';
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';

const Locations: React.FC = () => {
   
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders.activeManageOrder;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.locations}data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Timeline classes={{ root: styles.time_line }} >
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content }}>
                    <TimelineSeparator>
                        {
                            theme === 'dark' ? <img src="/origin-dark.svg" alt="origin" /> :
                            <img src="/origin.png" alt="origin" />
                        }
                        <TimelineConnector className={styles.connector} />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: styles.timeline_content_root }}>
                        <div className={styles.timeline_content}>
                            <p>{activeManageOrder?.origin_address}</p>
                            <span>{activeManageOrder?.origin_details}</span>
                        </div>
                    </TimelineContent>
                </TimelineItem>
                <div className={styles.connector_desktop}><hr /></div>
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content, root: styles.timelineItem_root }}>
                    <TimelineSeparator >
                        <img src="/destination.png" alt="destination" />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: styles.timeline_content_root }}>
                        <div className={styles.timeline_content}>
                            <p>{activeManageOrder?.destination_address}</p>
                            <span>{activeManageOrder?.destination_details}</span>
                        </div>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        </div>
    )
}
export default Locations;